<template>
  <div :class="clContainer()">
    <span v-if="label && !placeholder" :class="clSub('label', 'label')">{{
      label
    }}</span>

    <vue-google-autocomplete
      id="map"
      class="address-input form__input"
      ref="googelmap"
      :label="label"
      :name="name"
      :placeholder="placeholder ? placeholder : ''"
      v-model="addressString"
      autocomplete="off"
      v-on:placechanged="getAddressData"
      @inputChange="updateNewAddress"
      @input="
        dataChanged(true);
        validate();
      "
    ></vue-google-autocomplete>

    <slot name="append" :state="state"></slot>

    <div :class="clSub('errors')">
      <div
        v-for="(error, index) in errors"
        :class="clSub('error')"
        :key="index"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import Base from "./Base";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  extends: Base,
  components: { VueGoogleAutocomplete },
  props: {
    label: {
      type: String,
      default: "input",
    },
  },
  data() {
    return {
      data: null,
      address: null,
      addressString: "",
    };
  },
  created() {
    this.addDataProcessor(this.setAddressData, "set");

    this.addDataProcessor((newData) => {
      this.dataChanged();
    }, "setAfter");
  },

  methods: {
    getAddressData: function (addressData) {
      this.errors = [];
      let address =
        addressData.route +
        " " +
        addressData.street_number +
        ", " +
        addressData.locality +
        ", " +
        addressData.postal_code +
        " " +
        addressData.country;

      this.address = {
        route: addressData.route,
        street_name: addressData.route,
        street_number: addressData.street_number,
        city: addressData.locality,
        postal_code: addressData.postal_code,
        country: addressData.country,
        latitude: addressData.latitude,
        longitude: addressData.longitude,
        address: address,
      };

      this._setData(this.address);
      this.addressString = address;

      if (
        addressData.street_number == "" ||
        addressData.street_number == undefined
      ) {
        this.errors = ["Hausnummer angeben"];
      }
    },

    updateNewAddress(val, hasStringValue = "") {
      let value = "";
      if (hasStringValue != "string") {
        value = val.newVal;
      } else {
        if (typeof val === "object") {
          this.address = val;
          this.addressString = val.address;
          return;
        } else {
          value = val;
        }
      }

      this.errors = [];
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        {
          address: value,
        },
        (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            let addressData = results[0].address_components;

            let postalCode = "";
            let street_number = "";
            let street_name = "";
            let country = "";
            let city = "";
            let latitude = "";
            let longitude = "";

            if (addressData) {
              addressData.map((addressType) => {
                if (addressType.types.includes("street_number")) {
                  street_number = addressType.long_name;
                }
                if (addressType.types.includes("postal_code")) {
                  postalCode = addressType.long_name;
                }
                if (addressType.types.includes("route")) {
                  street_name = addressType.long_name;
                }
                if (addressType.types.includes("administrative_area_level_1")) {
                  city = addressType.long_name;
                }
                if (addressType.types.includes("country")) {
                  country = addressType.long_name;
                }
              });
            }

            let geoLocation = results[0].geometry
              ? results[0].geometry.location
              : "";
            if (geoLocation) {
              latitude = geoLocation.lat();
              longitude = geoLocation.lng();
            }

            this.address = {
              route: street_name,
              street_name: street_name,
              street_number: street_number,
              city: city,
              postal_code: postalCode,
              country: country,
              latitude: latitude,
              longitude: longitude,
              address: results[0].formatted_address,
            };

            this._setData(this.address);
            this.addressString = value;

            if (street_number == "" || street_number == undefined) {
              this.errors = ["Hausnummer angeben"];
            }
          }
        }
      );
    },
    setAddressData(newData) {
      this.updateNewAddress(newData, "string");
      return this.address;
    },
  },
};
</script>